import { render, staticRenderFns } from "./TermDialog.vue?vue&type=template&id=39d55f18&scoped=true&"
import script from "./TermDialog.vue?vue&type=script&lang=js&"
export * from "./TermDialog.vue?vue&type=script&lang=js&"
import style0 from "./TermDialog.vue?vue&type=style&index=0&id=39d55f18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d55f18",
  null
  
)

export default component.exports